import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import ScrollableProductGroups from 'modules/productGroups/scrollableProductGroups';
import ProductListFilters from './ProductListFilter/ProductListFilter';
import SortingHeader from './SortingHeader';
import CategorySideMenu from './CategoryMenu/CategorySideMenu';

export default function ProductListHeader({ model }: { model: ProductListPartialViewModel }) {
    const {
        showFiltersTop,
        showMenu,
        showProductGroupsOnMobile,
        productList: { menu }
    } = model;

    const hasCategoryMenu = showMenu && menu;

    if (!showFiltersTop && hasCategoryMenu) {
        // then we are on dior or chanel
        return (
            <Flex.Column>
                {hasCategoryMenu && <CategorySideMenu model={menu} />}
                <SortingHeader model={model} />
            </Flex.Column>
        );
    }

    return (
        <Flex.Column>
            {showFiltersTop && showProductGroupsOnMobile && <ScrollableProductGroups model={model.productGroups} />}
            {showFiltersTop && <ProductListFilters model={model} />}
            <SortingHeader model={model} />
        </Flex.Column>
    );
}
